export default {
  read(key) {
    return localStorage.getItem(key);
  },
  write(key, value) {
    localStorage.setItem(key, value);
  },
  readJSON(key) {
    return JSON.parse(localStorage.getItem(key));
  },
  writeJSON(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  remove(key) {
    localStorage.removeItem(key);
  },
};
